export enum ConfigurationView {
  CONFIGURATION_SUMMARY = 'CONFIGURATION_SUMMARY',
  CONFIGURATION_FINAL_SUMMARY = 'CONFIGURATION_FINAL_SUMMARY',
  CONFIGURATION_WIDGET = 'CONFIGURATION_WIDGET'
}
